module.exports = __webpack_public_path__ + "img/0-92.4b6a0034.jpg";